import { useTheme } from 'styled-components';
import React from 'react';
import { IIconProps } from './TIcon';

/** @deprecated Use icons from '@sighten/beacon/icons' instead */
export function SolarPanelIcon({ color: colorProp }: IIconProps) {
  const theme = useTheme();

  const color = colorProp || theme.colors.chartChartBlueSecondary2100;

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path
        d="M2.94333 1C2.1638 1 1.49418 1.5495 1.34083 2.3137L0.0322431 8.85662C-0.169667 9.86873 0.602193 10.8144 1.63475 10.8144H7.1809V12.4501H5.54517C5.09279 12.4501 4.7273 12.8156 4.7273 13.268C4.7273 13.7204 5.09279 14.0858 5.54517 14.0858H10.4524C10.9047 14.0858 11.2702 13.7204 11.2702 13.268C11.2702 12.8156 10.9047 12.4501 10.4524 12.4501H8.81663V10.8144H14.3628C15.3953 10.8144 16.1698 9.87128 15.9678 8.85662L14.6593 2.3137C14.5033 1.5495 13.8337 1 13.0542 1H2.94333ZM6.48827 2.63573H9.50926L9.77507 5.29379H6.22246L6.48827 2.63573ZM4.99055 5.29379H2.41172L2.94333 2.63573H5.2538L4.99055 5.29379ZM2.16636 6.52059H4.86787L4.60207 9.17865H1.63475L2.16636 6.52059ZM6.09978 6.52059H9.89774L10.1636 9.17865H5.83398L6.09978 6.52059ZM11.1297 6.52059H13.8312L14.3628 9.17865H11.398L11.1297 6.52059ZM13.5833 5.29379H11.007L10.7412 2.63573H13.0516L13.8542 2.47471L13.0542 2.63573L13.5858 5.29379H13.5833Z"
        fill={color}
      />
    </svg>
  );
}

export default SolarPanelIcon;
